<template>
  <div>
    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between >
        <v-flex xs12 sm6 class="pa-2">
          <v-layout row wrap>
            <v-flex shrink class="text-xs-center mr-3">
              <v-avatar size=48 >
                <v-icon color="primary" large>attach_money</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex shrink class="grey--text" >
              <h1 class="grey--text text--darken-2">
                Pricing and Access
              </h1>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="text-xs-right mr-3">
          <v-btn flat small color="primary" to="/jargon/policy">
            Policies
          </v-btn>|
          <v-btn flat small color="primary" to="/jargon/contact">
            Contact us
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row>
      <v-flex>
        <v-expansion-panel disabled v-model="pricingPanel">
          <v-expansion-panel-content class="v-expansion-panel-jargon">
            <v-card>
              <v-card-text>

                <h3 class="mb-2 grey--text text--darken-1">
                  What you get
                </h3>
                <p>
                  Access to Conductor is managed with seats.
                </p>

                <p>
                  Each seat
                  <ul class="mt-2">
                    <li>grants access to <strong>one user</strong></li>
                    <li>applies to <strong>one project</strong></li>
                    <li>lasts <strong>one month</strong> on use</li>
                    <li>costs <strong>$20.00</strong></li>
                  </ul>
                </p>

                <p>
                  Pricing in Conductor is as straight forward as you expect.
                  <ul class="mt-3">
                    <li>no recurring subscription</li>
                    <li>easy, prepaid, per user per project</li>
                  </ul>
                </p>

                <h3 class="mt-4 mb-2 grey--text text--darken-1">
                  How it works
                </h3>
                <p>
                  A seat is used when a user without a current/valid seat accesses your project. Typically, this the first time in a month that a user on your project logs in.
                </p>
                <p>
                  You can buy seats ahead of time, they do not expire until used.
                </p>
                <p>
                  If you run out of seats users can still log in, but they can't access or see your project until you get more seats. The project owner (you) always gets a free seat and always has access.
                </p>
                <p>
                   Conductor is a software service offering and buying a seat only buys you access.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
     </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'jargon-show',

    data () {
      return {
        pricingPanel: 0,
        policyPanel: 0,
        contactPanel: 0
      }
    },

    components: {
    },

    watch: {
    },

    mounted () {
    },

    computed: {
      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      }
    },

    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .v-expansion-panel-jargon {
    background-color: #0155a8 !important;
  }

  h3 {
    font-weight: normal;
    text-transform: uppercase;
  }

</style>



// WEBPACK FOOTER //
// src/components/jargon/pricing.vue